import PropTypes from 'prop-types';

export default function CustomizeSection({ children, title, className }) {
  return (
    <div className={className ? `${className}` : 'mb-8 mt-5'}>
      <div className="divider divider-start">
        {title && <span className="text text-gray-700 font-bold">{title}</span>}
      </div>
      {children}
    </div>
  );
}

CustomizeSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string
};
